import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';
import { OfflineComponentsModule } from '../general/offline/offline.components.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CachedImageComponentsModule } from '../general/cached-image/cached-image.components.module';
import { TicketAdminComponent } from './ticket-admin/ticket-admin.component';

@NgModule({
    declarations: [
      TicketDetailComponent,
      TicketAdminComponent,
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        TranslateModule,
        CachedImageComponentsModule,
        OfflineComponentsModule,
    ],
    exports: [
        TicketDetailComponent
    ],
})
export class ChatComponentsModule { }
